export default __webpack_public_path__ + "static/media/lobbyBanner.5116f527.png";